import comp from "./Groupedview";
export default comp;
